<template>
  <div>
        <div class="block-content">

          <div v-if="displayFlag"  class="col-sm-12 col-md-12">


            <h2 class="font-w300 align-center push-10">{{actualNews.title[actualLanguage]}}</h2>

            <div v-for="(section,index) in actualNews.sections">
                <h3 class="font-w300 align-center push-10">{{section.subTitle[actualLanguage]}}</h3>

                <div v-for="(line,index) in section.lines">
                  <p class="font-w300 align-center push-10">{{line[actualLanguage]}}</p>
                  
                </div>

                <div v-if="section.picture.length > 2"  class="col-xs-12 col-md-12 align-center">
                  <div class="form-group">
                    <p><img class = "img-responsive"  width="125px" :src="`news/${section.picture}` | s3Image"></p>
                  </div>
                </div>

            </div>

            <div class="col-xs-12 align-center">
              <div class="checkbox">
                  <label for="example-checkbox1">
                      <input v-model="dontShowAgainFlag" @click="toggleDontShowAgain" class="larger" type="checkbox" id="example-checkbox1" name="example-checkbox1" value="option1">{{labelDontShowAgain[actualLanguage]}}
                  </label>
              </div>
            </div>

            <div class="col-sm-12 col-md-12 align-center push">
              <button @click="closeModalWindow" class="btn btn-success align-center" type="button" name="button">
                <span>{{ labelButtonClose[actualLanguage] }}</span>
              </button>
            </div>



          </div>

        </div>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'DashboardNews',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      displayFlag : false,
      dontShowAgainFlag : false,
      dontShowAgainFlag2 : false,

      actualLanguage : "FR",
      actualNews : {},
      labelSectionUser: {FR: 'Accès usager', EN: 'User access'},
      labelDontShowAgain: {FR: 'Ne plus afficher cet avis.', EN: 'Do not display this notice again.'},
      labelButtonClose: {FR: 'Fermer cette fenêtre', EN: 'Close this window'},

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  methods: {

    closeModalWindow(){
      this.$store.dispatch('overlayStore/toggleModal',false)
    },

    toggleDontShowAgain(){
      this.dontShowAgainFlag2 = !this.dontShowAgainFlag
      this.applyShowAgainChoice()
    },

    applyShowAgainChoice(){
        var requestData = {'postAction':'ChangeDashboardNewsFlag',
                          'newsIndex':this.overlayParameters.newsIndex,
                          'flagValue':this.dontShowAgainFlag2}

        this.$store.dispatch('sessionStore/postProfile', requestData)
            .then((response) => {
            if(response.data.Code !='OK'){
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

  },


  mounted() {
    this.actualNews = this.profileData.dashboard_news[this.overlayParameters.newsIndex]
    this.displayFlag = true

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

  }


}
</script>



// WEBPACK FOOTER //
// DashboardNews.vue?7a151424